import React from 'react'
import { groupBy, map, sortBy } from 'lodash'
import {
  DefaultCoverageDetails,
  SummaryCell,
  AntiVirusCell,
  PatchingCell,
  AntiVirusDetails,
  PatchingDetails,
  BackupCell,
  BackupDetails,
  MonitoringCell,
  DataProtectionCell,
  DataProtectionDetails,
  MonitoringDetails
} from 'FoundationalComponents/Reports/CoverageReportCells'
import { sortCoverageSummary } from 'FoundationalComponents/Reports/ColumnHelpers'
import RAGIcon from '../../../../components/Foundational/RAGIcon'

const generateCoverageSummaryValue = (data, field, detailsFunction = DefaultCoverageDetails) => (
  sortBy(map(
    groupBy(data.assets, field),
    (assets, status) => ({ ...detailsFunction(status), count: assets.length })
  ), 'color')
)

const assetColumns = () => [
  { Header: 'Hostname', accessor: 'name', Cell: ({ value }) => <div className='mb-1 mt-1'>{value}</div> },
  { Header: 'Device Type', accessor: 'device_type' },
  { Header: 'Machine Type', accessor: 'machine_type' },
  {
    Header: 'Data protection',
    accessor: 'data_protection_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) =>  <DataProtectionCell {...{ value }} />,
  },
  {
    Header: 'Monitoring',
    accessor: 'monitoring_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) => <MonitoringCell {...{ value }} />,
  },
  {
    Header: 'Antivirus',
    accessor: 'antivirus_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value, original }) => <AntiVirusCell {...{ value, antivirus_product: original.antivirus_product }} />,
  },
  {
    Header: 'Patching',
    accessor: 'patching_coverage_status',
    width: 130,
    style: { background: '#F2F2F2' },
    Cell: ({ value }) => <PatchingCell {...{ value }} />,
  },
  { Header: 'Device Last Seen', accessor: 'last_seen_in_words' },
]

const customerColumns = () => [
  { Header: 'Customer', accessor: 'customer_name', filterable: true, type: 'clientNameWithStatus' },
  { Header: 'Devices', accessor: 'assets.length', type: 'number', width: 100 },
  {
    Header: 'Data Protection', id: 'data_protection',
    style: { background: '#F2F2F2', alignSelf: 'center' },
    Cell: SummaryCell, type: 'number',
    sortMethod: sortCoverageSummary,
    accessor: (data) => generateCoverageSummaryValue(data, 'data_protection_coverage_status', DataProtectionDetails),
  },
  {
    Header: 'Monitoring', id: 'monitoring',
    style: { background: '#F2F2F2' }, Cell: SummaryCell, type: 'number',
    accessor: (data) => generateCoverageSummaryValue(data, 'monitoring_coverage_status', MonitoringDetails),
    style: { alignSelf: 'center' },
  },
  {
    Header: 'Antivirus', id: 'antivirus',
    style: {  alignSelf: 'center', background: '#F2F2F2' }, Cell: SummaryCell, type: 'number',
    sortMethod: sortCoverageSummary,
    accessor: (data) => generateCoverageSummaryValue(data, 'antivirus_coverage_status', AntiVirusDetails),
  },
  {
    Header: 'Patching', id: 'patching',
    style: { background: '#F2F2F2', alignSelf: 'center' },
    Cell: SummaryCell, type: 'number',
    sortMethod: sortCoverageSummary,
    accessor: (data) => generateCoverageSummaryValue(data, 'patching_coverage_status', PatchingDetails),
  },
]

export { assetColumns, customerColumns }
